import { createReducer, on } from '@ngrx/store';
import { ClientDevice, MergeArrayValues, User, UserNotification, UserSessionData } from '@prism/prism-shared';
import { CoreActions } from '.';



export interface CoreState {
  currentUser: User | null;
  users: User[];
  currentClientDevice: ClientDevice | null;

  userSessionData: UserSessionData;

  userNotifications: UserNotification[];

  loadingState: number;
  error: any;
}

export const initialState: CoreState = {
  currentUser: null,
  users: [],
  currentClientDevice: null,

  userSessionData: {},

  userNotifications: [],

  loadingState: 0,
  error: null,
};



export const coreReducer = createReducer(
  initialState,
  // =====================================================================
  on(CoreActions.ClearCurrentUser, (state): CoreState => ({
    ...state,
    currentUser: null,
  })),
  // =====================================================================
  on(CoreActions.LoadCurrentUser, (state): CoreState => ({
    ...state,
    loadingState: state.loadingState + 1,
    error: null
  })),
  on(CoreActions.LoadCurrentUserSuccess, (state, { user }): CoreState => ({
    ...state,
    currentUser: user,
    loadingState: state.loadingState - 1,
    error: null
  })),
  on(CoreActions.SetCurrentUser, (state, { user }): CoreState => ({
    ...state,
    currentUser: user,
  })),
  on(CoreActions.LoadCurrentUserError, (state, { error }): CoreState => ({
    ...state,
    loadingState: state.loadingState - 1,
    error: error
  })),
  // =====================================================================
  on(CoreActions.LoadUsers, (state): CoreState => ({
    ...state,
    loadingState: state.loadingState + 1,
    error: null
  })),
  on(CoreActions.LoadUsersSuccess, (state, { users }): CoreState => ({
    ...state,
    users: users,
    loadingState: state.loadingState - 1,
    error: null
  })),
  on(CoreActions.LoadUsersError, (state, { error }): CoreState => ({
    ...state,
    loadingState: state.loadingState - 1,
    error: error
  })),
  // =====================================================================
  on(CoreActions.LoadUserById, (state): CoreState => ({
    ...state,
    loadingState: state.loadingState - 1,
    error: null
  })),
  on(CoreActions.LoadUserByIdSuccess, (state, { user }): CoreState => ({
    ...state,
    users: MergeArrayValues(state.users, user),
    loadingState: state.loadingState - 1,
    error: null
  })),
  on(CoreActions.LoadUserByIdError, (state, { error }): CoreState => ({
    ...state,
    loadingState: state.loadingState - 1,
    error: error
  })),
  // =====================================================================
  on(CoreActions.UpdateCurrentUser, (state, { user }): CoreState => ({
    ...state,
    currentUser: user,
  })),
  // =====================================================================
  on(CoreActions.UpdateUser, (state, { user }): CoreState => ({
    ...state,
    users: MergeArrayValues(state.users, user),
  })),
  // =====================================================================
  on(CoreActions.SetCurrentClientDevice, (state, { clientDevice }): CoreState => ({
    ...state,
    currentClientDevice: clientDevice,
  })),
  // =====================================================================
  on(CoreActions.SetUserSessionData, (state, { userSessionData }): CoreState => ({
    ...state,
    userSessionData,
  })),
  // =====================================================================
  on(CoreActions.SetUserNotifications, (state, { userNotifications }): CoreState => ({
    ...state,
    userNotifications,
  }))
);


